import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import AppDashboard from '@/components/AppDashboard.vue';
import ErrorDisplay from '@/components/ErrorDisplay.vue';
import {useSettings} from '@/store/settings';
import {DashboardModule, generateModule} from '@/util/dashboard';


export default /*#__PURE__*/_defineComponent({
  __name: 'Dashboard',
  setup(__props, { expose: __expose }) {

const settingsStore = useSettings();

const modules: DashboardModule[] = [
  generateModule('crm'),
  generateModule('followup_module'),
  generateModule('picklist'),
  generateModule('order'),
  generateModule('inventory'),
  generateModule('suggestion'),
  generateModule('correction'),
  generateModule('umbuchung'),
  generateModule('article'),
];

__expose({
  AppDashboard,
  ErrorDisplay,
  modules,
  settingsStore,
});

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      (_unref(settingsStore).licensesLoading)
        ? (_openBlock(), _createBlock(_component_v_layout, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_progress_circular, { indeterminate: "" }),
              _createVNode(_component_v_spacer)
            ], undefined, true),
            _: 1
          }))
        : (_unref(settingsStore).licensesError)
          ? (_openBlock(), _createBlock(ErrorDisplay, {
              key: 1,
              message: _unref(settingsStore).licensesError?.message,
              loading: _unref(settingsStore).licensesLoading,
              onRetry: _unref(settingsStore).fetchLicences
            }, null, 8, ["message", "loading", "onRetry"]))
          : (_openBlock(), _createBlock(AppDashboard, {
              key: 2,
              modules: modules
            }))
    ], undefined, true),
    _: 1
  }))
}
}

})